import { useMemo } from 'react'
import { isDistrict, isGroup, isRGD, isRegion, isStore } from 'utils/location'
import { useUser } from 'components/user-context/user-context'

export default function useLocationName(): String {
    const { location } = useUser()
    return useMemo(() => {
        let locationAsString = location.shortName.toString()
        if (isStore(locationAsString)) {
            return `${location.name} ${location.shortName}`
        } else if (isRGD(locationAsString)) {
            if (isRegion(locationAsString)) {
                return `Region ${location.locationId}`
            }
            if (isGroup(locationAsString)) {
                return `Group ${location.locationId}`
            }
            if (isDistrict(locationAsString)) {
                return `District ${location.locationId}`
            }
        }
        return 'Company Target'
    }, [location])
}

export function transformLocation(location: string) {
    // Check if the location is already in the correct format (e.g., G199, D100, R200)
    if (/^[A-Z]\d+$/.test(location)) {
        return location
    }
    const match = location.match(/^(\w)\w*\s+(\d+)$/)
    if (match) {
        const [, firstLetter, number] = match
        return `${firstLetter.toUpperCase()}${number}`
    }

    return location.toString()
}
